const cwsAnimation = () => {
  const elements = document.querySelectorAll(".animation-box");
  const isInViewport = (elem) => {
    const rect = elem.getBoundingClientRect();

    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const windowWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

    return vertInView && horInView;
  };

  const animatedFunct = (box) => {
    const animateBox = box.querySelectorAll(".animation-el");

    animateBox.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add("animated");
      }, 100 * index);
    });
  };

  elements.forEach((element) => {
    if (isInViewport(element)) {
      animatedFunct(element);
    }

    window.addEventListener("scroll", () => {
      if (window.scrollY + window.outerHeight / 1.5 > element.offsetTop) {
        animatedFunct(element);
      }
    });
  });
};

cwsAnimation();
